// extracted by mini-css-extract-plugin
export default {"container":"Skills_container__WJh2m","wrapper":"Skills_wrapper__vpMQm","row":"Skills_row__caXYu","tags":"Skills_tags__Rh5iF"};